import { ref } from "vue";

interface Constants {
	area: string;
	domain: string;
	pointId: string;
	orgId: string;
	currency_symbol: string;
	default_language: string;
	has_loyalty_default_user: string;
	loyalty: string;
	infinite_feed_qr: boolean;
	qr_enable_flat_product_feed: boolean;
	name: string;
	quick_add_simple: null;
	supported_languages: string[];
	kiosk_order_minimum_price: number;
	qr_order_minimum_price: number;
	enable_sequential_modifiers: boolean;
	default_table: string | null;
	is_hidden?: boolean | null;
	default_country_code?: string | null;
	order_types?: Array<{
		id: string;
		name: string;
		image_link?: string;
		type?: string;
	}>;
	order_item_comment_suggestions: string[] | null;
	reserve_enabled: boolean;
}

const area = `${import.meta.env.VITE_AREA ?? "stage"}.inno-clouds.ru`;
const domain = import.meta?.env?.MODE !== "https" ? import.meta.env.VITE_API_URL : "";

const constants = ref<Constants>({
	area,
	domain,
	pointId: "",
	orgId: "",
	currency_symbol: "",
	default_language: "",
	has_loyalty_default_user: "",
	loyalty: "",
	infinite_feed_qr: false,
	qr_enable_flat_product_feed: false,
	name: "",
	quick_add_simple: null,
	supported_languages: [],
	kiosk_order_minimum_price: 0,
	qr_order_minimum_price: 0,
	enable_sequential_modifiers: false,
	default_table: null,
	is_hidden: null,
	default_country_code: null,
	order_types: [],
	order_item_comment_suggestions: null,
	reserve_enabled: false,
});

export default constants;
